import { z } from 'zod';

import {
  ListStonesShape,
  ListStonesStatus,
  ListStonesStoneType,
  type ListStonesParams,
} from '@nucleus-commerce/api-client/platform';

/** URL search of /diamonds: the tab and the stone filters GET /platform/v1/stones accepts. */
export const diamondsSearchSchema = z.object({
  tab: z.enum(['stones', 'suppliers']).optional().catch(undefined),
  stoneType: z.enum(ListStonesStoneType).optional().catch(undefined),
  shape: z.enum(ListStonesShape).optional().catch(undefined),
  status: z.enum(ListStonesStatus).optional().catch(undefined),
  supplierId: z.string().min(1).max(64).optional().catch(undefined),
  q: z.string().trim().min(1).max(120).optional().catch(undefined),
});

export type DiamondsSearch = z.infer<typeof diamondsSearchSchema>;

export type StoneFilters = Omit<DiamondsSearch, 'tab'>;

export function stoneListParams(search: DiamondsSearch): ListStonesParams {
  return {
    ...(search.stoneType ? { stoneType: search.stoneType } : {}),
    ...(search.shape ? { shape: search.shape } : {}),
    ...(search.status ? { status: search.status } : {}),
    ...(search.supplierId ? { supplierId: search.supplierId } : {}),
    ...(search.q ? { q: search.q } : {}),
  };
}
